var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultAvatar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_15_profile_avatar_default",
    "data-name": "15 profile avatar default",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_315",
    "data-name": "Ellipse 315",
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#eee"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_user",
    "data-name": "icon user",
    transform: "translate(26.667 23.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M31.359,14.444A12.565,12.565,0,1,1,18.795,2,12.5,12.5,0,0,1,31.359,14.444Z",
    transform: "translate(4.538 -2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M3,29.5c0-10.473,8.154-18.963,18.211-18.963H31.455c10.058,0,18.211,8.49,18.211,18.963a5.812,5.812,0,0,1-5.691,5.926H8.691A5.812,5.812,0,0,1,3,29.5Z",
    transform: "translate(-3 17.911)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default-avatar.f9872cf2d475bfba1a9d0f0bc247995a.svg";
export { ForwardRef as ReactComponent };